module.exports = __webpack_public_path__ + "img/boleto-red.4ef11297.svg";